if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.addEventListener('click', (event) => {
  const label = event.target.closest('.swatch-input__label');
  if (!label) return;

  const input = this.querySelector(`#${CSS.escape(label.htmlFor)}`);
  if (!input) return;

  const optionName = input.dataset.optionName?.toLowerCase();

  if (
    (optionName === 'color' || optionName === 'colour') &&
    input.dataset.metaSwatchImage
  ) {
    this.showMetaobjectSwatchImage(
      input.dataset.metaSwatchImage,
      input.value,
      input.dataset.metaSwatchCaption
    );
  }
});

this.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('.thumbnail');
  if (!thumbnail) return;

  this.hideMetaobjectSwatchImage();

  const caption = this.querySelector('[data-gallery-caption]');
  if (!caption) return;

  caption.textContent = thumbnail.dataset.mediaCaption || '';
});

this.addEventListener('click', (event) => {
  const backButton = event.target.closest(
    '[data-back-to-product-image]'
  );

  if (!backButton) return;

  this.hideMetaobjectSwatchImage();

  const caption = this.querySelector('[data-gallery-caption]');
const originalImage = this.querySelector(
  'media-gallery .product__media-item[data-media-id]'
);

if (caption && originalImage) {
  caption.textContent = originalImage.dataset.mediaCaption || '';
}
});


this.addEventListener('click', (event) => {
  const familyButton = event.target.closest('.color-family-button');
  if (!familyButton) return;

  const fieldset = familyButton.closest('[data-swatch-dropdown-group]');
  if (!fieldset) return;

  const selectedFamily = familyButton.dataset.family;

  fieldset.querySelectorAll('.color-family-button').forEach((button) => {
    button.classList.toggle('is-active', button === familyButton);
  });

  fieldset
    .querySelectorAll('.swatch-options-wrapper input[data-color-family]')
    .forEach((input) => {
      const label = fieldset.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      const show =
        selectedFamily === 'all' ||
        input.dataset.colorFamily === selectedFamily;

      input.style.display = show ? '' : 'none';

      if (label) {
        label.style.display = show ? '' : 'none';
      }
    });

    const soldOutLabel = fieldset.querySelector('[data-sold-out-divider]');

if (soldOutLabel) {
  const visibleSoldOut = Array.from(
    fieldset.querySelectorAll(
      '.swatch-options-wrapper input.visually-disabled[data-color-family]'
    )
  ).some((input) => {
    return (
      selectedFamily === 'all' ||
      input.dataset.colorFamily === selectedFamily
    );
  });

  soldOutLabel.style.display = visibleSoldOut ? 'inline-flex' : 'none';
}
});

this.addEventListener('change', (event) => {
  const dropdown = event.target.closest('[data-swatch-dropdown]');
  if (!dropdown) return;

  const group = dropdown.closest('[data-swatch-dropdown-group]');
  if (!group) return;

  const allButton = group.querySelector(
    '.color-family-button[data-family="all"]'
  );

  if (allButton && !allButton.classList.contains('is-active')) {
    allButton.click();
  }
});

       this.initQuantityHandlers();
this.arrangeSoldOutSwatches();
this.initializeChooseColorState();

this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

showMetaobjectSwatchImage(imageUrl, altText = '', captionText = '') {
  if (!imageUrl) return;

  const gallery = this.querySelector('media-gallery');
  if (!gallery) return;

  const mediaArea =
    gallery.querySelector('.product__media-list') ||
    gallery.querySelector('ul');

  if (!mediaArea) return;

  let preview = mediaArea.querySelector('[data-meta-swatch-preview]');

  if (!preview) {
    preview = document.createElement('div');
    preview.setAttribute('data-meta-swatch-preview', '');
    preview.style.position = 'absolute';
    preview.style.inset = '0';
    preview.style.zIndex = '1';
    preview.style.display = 'flex';
    preview.style.alignItems = 'flex-start';
    preview.style.justifyContent = 'center';
    preview.style.background = 'rgb(var(--color-background))';
    preview.style.pointerEvents = 'none';

    const image = document.createElement('img');
    image.setAttribute('data-meta-swatch-preview-image', '');
    image.style.display = 'block';
    image.style.width = '100%';
image.style.height = 'auto';
image.style.maxHeight = '100%';
image.style.objectFit = 'contain';

    preview.appendChild(image);

    
const backButton = document.createElement('button');
backButton.type = 'button';
backButton.setAttribute('data-back-to-product-image', '');
backButton.textContent = '← Back to Product Image';

backButton.style.position = 'absolute';
backButton.style.bottom = '12px';
backButton.style.left = '50%';
backButton.style.transform = 'translateX(-50%)';
backButton.style.zIndex = '2';
backButton.style.padding = '10px 16px';
backButton.style.background = '#ffffff';
backButton.style.color = '#222222';
backButton.style.border = '1px solid #cccccc';
backButton.style.borderRadius = '4px';
backButton.style.cursor = 'pointer';
backButton.style.pointerEvents = 'auto';


const galleryImageCount = gallery.querySelectorAll(
  '.product__media-list li[data-media-id]'
).length;

if (galleryImageCount > 1) {
  backButton.style.display = 'none';
}


preview.appendChild(backButton);


    if (window.getComputedStyle(mediaArea).position === 'static') {
      mediaArea.style.position = 'relative';
    }

    mediaArea.appendChild(preview);

  
  }

  const image = preview.querySelector('[data-meta-swatch-preview-image]');

  if (image) {
    image.src = imageUrl;
    image.alt = altText || 'Selected color';
  }

const caption = this.querySelector('[data-gallery-caption]');

if (caption) {
  caption.textContent = captionText || altText || '';
}

  preview.style.display = 'flex';
}

hideMetaobjectSwatchImage() {
  const preview = this.querySelector(
    'media-gallery [data-meta-swatch-preview]'
  );

  if (preview) {
    preview.style.display = 'none';
  }
}

showSelectedColorSwatchPreview() {
  const variantSelectors = this.variantSelectors;
  if (!variantSelectors) return;

  const selectedColor = variantSelectors.querySelector(
    'input[data-meta-swatch-image][data-option-name="Color"]:checked,' +
    'input[data-meta-swatch-image][data-option-name="Colour"]:checked'
  );

  if (selectedColor?.dataset.metaSwatchImage) {
    this.showMetaobjectSwatchImage(
  selectedColor.dataset.metaSwatchImage,
  selectedColor.value,
  selectedColor.dataset.metaSwatchCaption
);
  }
}

initializeChooseColorState() {
  // If somebody opened a direct variant URL, keep that variant selected.
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('variant')) return;

  const variantSelectors = this.variantSelectors;
  if (!variantSelectors) return;

  const colorInputs = variantSelectors.querySelectorAll(
    'input[data-option-name="Color"], input[data-option-name="Colour"]'
  );

  if (!colorInputs.length) return;

  // Remove Shopify's automatic first-color selection.
  colorInputs.forEach((input) => {
    input.checked = false;
  });

  const colorGroup = colorInputs[0].closest('[data-swatch-dropdown-group]');

  // Change "Color: Butterscotch" to "Color: Choose a Color"
  const selectedValue = colorGroup?.querySelector('[data-selected-value]');
  if (selectedValue) {
    selectedValue.textContent = 'Choose a Color';
  }

  // Make the dropdown also show "Choose a Color"
  const dropdown = colorGroup?.querySelector('[data-swatch-dropdown]');

  if (dropdown) {
    let placeholder = dropdown.querySelector('[data-color-placeholder]');

    if (!placeholder) {
      placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Choose a Color';
      placeholder.disabled = true;
      placeholder.dataset.colorPlaceholder = 'true';

      dropdown.prepend(placeholder);
    }

    placeholder.selected = true;
    dropdown.value = '';
  }

  // Remove Shopify's automatically selected variant ID.
  this.querySelectorAll(
    `#product-form-${this.dataset.section} input[name="id"],
     #product-form-installment-${this.dataset.section} input[name="id"]`
  ).forEach((input) => {
    input.value = '';
  });

  // Disable Add to Cart until a color is chosen.
  this.productForm?.toggleSubmitButton(true, 'Choose a Color');
}

arrangeSoldOutSwatches() {
  const groups = this.querySelectorAll('[data-swatch-dropdown-group]');

  groups.forEach((group) => {
    const wrapper = group.querySelector('.swatch-options-wrapper');
    if (!wrapper) return;

    const inputs = Array.from(
      wrapper.querySelectorAll('input.swatch-input__input')
    );

    if (!inputs.length) return;

    const availableItems = [];
    const soldOutItems = [];

    inputs.forEach((input) => {
      const label = wrapper.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      if (!label) return;

      if (input.classList.contains('visually-disabled')) {
        soldOutItems.push({ input, label });
      } else {
        availableItems.push({ input, label });
      }
    });

    wrapper.innerHTML = '';

    availableItems.forEach(({ input, label }) => {
      wrapper.appendChild(input);
      wrapper.appendChild(label);
    });

    if (soldOutItems.length) {
      const soldOutLabel = document.createElement('span');
      soldOutLabel.className = 'sold-out-label';
      soldOutLabel.dataset.soldOutDivider = 'true';
      soldOutLabel.textContent = 'SOLD OUT';

      wrapper.appendChild(soldOutLabel);

      soldOutItems.forEach(({ input, label }) => {
        wrapper.appendChild(input);
        wrapper.appendChild(label);
      });
    }
  });
}

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
  if (!this.contains(event.target)) return;

  const optionName = target.dataset.optionName?.toLowerCase();

  if (
    (optionName === 'color' || optionName === 'colour') &&
    target.dataset.metaSwatchImage
  ) {
    this.showMetaobjectSwatchImage(
  target.dataset.metaSwatchImage,
  target.value,
  target.dataset.metaSwatchCaption
);
  }

  this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const sourceProductInfo = html.querySelector(selector);
          const variant = this.getSelectedVariant(sourceProductInfo);
          this.variantSelectors?.resolvePendingSelectPromise(variant, this.getVariantSelects(sourceProductInfo));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
            this.variantSelectors?.rejectPendingSelectPromise(error);
          });
      }

      parseJsonScript(parent, selector) {
        try {
          return JSON.parse(parent?.querySelector(selector)?.textContent);
        } catch {
          return null;
        }
      }

      getVariantSelects(queryRoot) {
        return queryRoot?.querySelector('variant-selects');
      }

      getSelectedVariant(productInfoNode) {
        return this.parseJsonScript(this.getVariantSelects(productInfoNode), '[data-selected-variant]');
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const sourceVariantSelects = this.getVariantSelects(html);
          const variant = this.getSelectedVariant(html);

          // Resolve product:select promise before updateOptionValues replaces the variant-selects DOM element
          this.variantSelectors?.resolvePendingSelectPromise(variant, sourceVariantSelects);

          const activeColorFamily =
  this.querySelector('.color-family-button.is-active')?.dataset.family || 'all';

/* Prepare the refreshed picker BEFORE Dawn displays it */
const incomingColorGroup = html.querySelector('[data-swatch-dropdown-group]');

if (incomingColorGroup) {
  incomingColorGroup
    .querySelectorAll('.color-family-button')
    .forEach((button) => {
      button.classList.toggle(
        'is-active',
        button.dataset.family === activeColorFamily
      );
    });

  incomingColorGroup
    .querySelectorAll('.swatch-options-wrapper input[data-color-family]')
    .forEach((input) => {
      const label = incomingColorGroup.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      const show =
        activeColorFamily === 'all' ||
        input.dataset.colorFamily === activeColorFamily;

      input.style.display = show ? '' : 'none';

      if (label) {
        label.style.display = show ? '' : 'none';
      }
    });
}

this.pickupAvailability?.update(variant);
this.updateOptionValues(html);
this.arrangeSoldOutSwatches();

const refreshedGroup = this.querySelector('[data-swatch-dropdown-group]');

if (refreshedGroup) {
  refreshedGroup.querySelectorAll('.color-family-button').forEach((button) => {
    button.classList.toggle(
      'is-active',
      button.dataset.family === activeColorFamily
    );
  });

  refreshedGroup
    .querySelectorAll('.swatch-options-wrapper input[data-color-family]')
    .forEach((input) => {
      const label = refreshedGroup.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );

      const show =
        activeColorFamily === 'all' ||
        input.dataset.colorFamily === activeColorFamily;

      input.style.display = show ? '' : 'none';

      if (label) {
        label.style.display = show ? '' : 'none';
      }
    });

  const soldOutLabel =
    refreshedGroup.querySelector('[data-sold-out-divider]');

  if (soldOutLabel) {
    const visibleSoldOut = Array.from(
      refreshedGroup.querySelectorAll(
        '.swatch-options-wrapper input.visually-disabled[data-color-family]'
      )
    ).some((input) => {
      return (
        activeColorFamily === 'all' ||
        input.dataset.colorFamily === activeColorFamily
      );
    });

    soldOutLabel.style.display = visibleSoldOut ? 'inline-flex' : 'none';
  }
}

this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);
this.showSelectedColorSwatchPreview();

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
